export type StretchMarksValue = string | null

export interface StretchMarksOption {
    key: string
    label: string
    description: string
    tooltip: string
}

export const STRETCH_MARKS_OPTIONS: StretchMarksOption[] = [
    {
        key: 'rubra',
        label: 'Rubra',
        description: 'Estágio recente — avermelhada ou arroxeada, pode coçar',
        tooltip: 'Fase inicial/inflamatória: estria avermelhada ou arroxeada, por vezes com prurido, devido ao aumento da vascularização na derme. Responde melhor a tratamentos nesta fase.',
    },
    {
        key: 'alba',
        label: 'Alba',
        description: 'Estágio avançado — esbranquiçada e atrófica',
        tooltip: 'Fase crônica/cicatricial: estria esbranquiçada, atrófica, com colágeno já reorganizado. Mais resistente a tratamentos que a fase rubra.',
    },
]

export function findStretchMarksOption(key: StretchMarksValue): StretchMarksOption | null {
    return STRETCH_MARKS_OPTIONS.find((option) => option.key === key) ?? null
}

export function isStretchMarksValueEmpty(value: StretchMarksValue | undefined): boolean {
    return !value
}
